// extracted by mini-css-extract-plugin
export default {"title":"CooperactionChannel_title_BbSd2","content":"CooperactionChannel_content_GkvOD"};